export const taxonomyByProductType = (productType: string) => {
  const [category, subcategory, subcat_type] = productType.split('-');
  return {
    category,
    subcategory: [category, subcategory].join('-'),
    subcat_type: subcat_type != null ? [category, subcategory, subcat_type].join('-') : null,
  };
};
